import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box } from '@material-ui/core'

import get from 'lodash/get'

import { contrastColor } from 'common/utils/Color'

import Icon from 'common/components/base/Icon'
import Typography from 'common/components/base/Typography'

import useStyles from './useStyles'

export interface HandoverDialogSuccessProps {
  shipment: any
}

const HandoverDialogSuccess: React.FC<HandoverDialogSuccessProps> = ({
  shipment,
}) => {
  const { t } = useTranslation()
  const classes = useStyles()

  const recipient =
    get(shipment, 'originalRecipient') || get(shipment, 'recipient')

  const newRecipient = get(shipment, 'recipient')

  const color = React.useMemo(
    () =>
      contrastColor(shipment.tour.color) === '#ffffff' ? 'white' : 'indigo',
    [shipment.tour.color],
  )

  return (
    <div className={classes.content}>
      <div
        style={{ backgroundColor: shipment.tour.color }}
        className="flex flex-col items-center justify-center p-4"
      >
        <Typography variant="header" color={color}>
          {t('CART')}
        </Typography>
        <div className="h-40" />
        <div className={classes.tourNr} color={color}>
          {get(shipment, 'tour.number')}
        </div>
        <div className="h-40" />
        <div>
          <Typography variant="header" color={color}>
            Tour: {get(shipment, 'tour.id')}
          </Typography>
          <Typography variant="header" color={color}>
            Position: {get(shipment, 'position')}
          </Typography>
        </div>
      </div>
      <div>
        <div className="p-3 h-full">
          <Typography variant="textBold">{t('TOUR')}</Typography>
          <Typography>{get(shipment, 'tour.id')}</Typography>
          <div className="h-16" />

          <Typography variant="textBold">{t('DRIVER')}</Typography>
          <Typography>{get(shipment, 'driver.name')}</Typography>
          <div className="h-16" />

          <Typography variant="textBold">{t('ADDRESS')}</Typography>
          <Typography>{get(recipient, 'name')}</Typography>
          <Typography>T. {get(recipient, 'phoneNumber')}</Typography>
          <Typography>{get(recipient, 'location.address')}</Typography>
          <Typography>{get(recipient, 'location.postalCode')}</Typography>
          <div className="h-16" />

          {get(shipment, 'originalRecipient ') &&
            get(shipment, 'recipient') && (
              <div>
                <div className="flex items-center mb-2">
                  <div className="mr-1 h-24">
                    <Icon name="danger" />
                  </div>
                  <Typography variant="textBold" transform="none">
                    {t('SHIPMENT_ADDRESS_CHANGED')}
                  </Typography>
                </div>
                <div>
                  <Typography variant="textBold">{t('NEW_ADDRESS')}</Typography>
                  <Typography>{get(newRecipient, 'name')}</Typography>
                  <Typography>T. {get(newRecipient, 'phoneNumber')}</Typography>
                  <Typography>
                    {get(newRecipient, 'location.address')}
                  </Typography>
                  <Typography>
                    {get(newRecipient, 'location.postalCode')}
                  </Typography>
                </div>
              </div>
            )}
        </div>
      </div>
    </div>
  )
}

export default HandoverDialogSuccess
